export default "__VITE_ASSET__CmR6r64U__"